// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"79145004","823":"85b974ef"}[chunkId] + ".chunk.js";
};